import Vue from "vue"
import Vuetify, { colors } from "vuetify/lib"

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: "md" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    theme: {
        options: {
            customProperties: true
        },
        dark: false,
        themes: {
            light: {
                primary: "#cc7400",
                secondary: "#0A2233",//"#555",
                accent: colors.shades.black,
                error: colors.red.darken2,
                // info: "",
                // success: "",
                warning: "#da4f49",
                anchor: '#0A2233',
                complete: '#daebcf',
            },
            dark: {
                // TODO
            }
        }
    }
})
